import React from 'react';
import './footer.css';

export default function Footer() {
    return (
        <div className="footer">
            <h6>All Rights Reserved</h6>
        </div>
    )
}